import { useParams } from "react-router-dom";
import styled from "styled-components";
import Overlay from "../../Componentes/Overlay";
import { useModal } from "../../contexts/ModalContext";
import SideMenu from "../../Componentes/SideMenu";
import SideMenuBtn from "../../Componentes/SideMenuBtn";
import ModalAddCandidato from "./ModalAddCandidato";
import { useEffect, useState } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import Modal from "../../Componentes/Utils/Modal";
import SmallLoading from "../../Componentes/Utils/SmallLoading";

const InfoVotacao = styled.div`
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    color: #cfd8dc;
    margin-top: 15px;
    margin-bottom: 15px;
    box-sizing: border-box;
    p {
        margin: 0;
    }
`
const ListaCandidatos = styled.div`
    flex: 1;
    box-sizing: border-box;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        display: none;
    }
    border-top: 2px solid #fff;
`
const CanditatoRow = styled.div`
    width: 100%;
    height: 450px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 10px;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    display: flex;

    @media (max-width: 768px) {
        flex-direction: column;
        padding: 15px;
        gap: 10px;
        padding: 5px;
    }
`
const Containerinfo = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
`
const Foto = styled.div`
    width: 70px;
    height: 70px;
    border-radius: 50%;
    overflow: hidden;
    box-sizing: border-box;
    margin: auto 10px auto 15px;
    & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    background-color: #ddd;
    flex-shrink: 0;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);

    @media (max-width: 768px){
        width: 110px;
        height: 147px;
        border-radius: 10px;
        margin: 0;
    }
`
const CandidatoInfo = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    margin: 5px;
    align-items: flex-start;
    justify-content: center;
    gap: 3px;

    @media ( max-width: 768px ){
        justify-content: flex-start;
        margin-left: 10px;
    }
`
const Nome = styled.div`
    font-weight: bold;
    font-size: 16px;
    color: #000;

    @media ( max-width: 768px ){
        font-size: 12px;
    }
`
const Funcao = styled.div`
    font-size: 14px;
    color: #555;

    @media ( max-width: 768px ){
        font-size: 10px;
    }
`
const Numero = styled.div`
    font-size: 14px;
    color: #777;

    @media ( max-width: 768px ){
        font-size: 10px;
    }
`
const ContainerVotos = styled.div`
    position: relative;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    margin: auto 15px auto 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border: 3px solid #000;

    @media ( max-width: 768px ){
        display: none;
    }
`
const QuantidadeVotos = styled.p`
    font-size: 18px;
    font-weight: bold;
    color: #000;
    text-align: center;
    margin: auto auto 0 auto;
`
const Votos = styled.p`
    font-size: 12px;
    color: #555;
    text-align: center;
    margin: 0 auto auto auto;
`
const VotosContainerMobile = styled.div`
    margin: auto auto 0 0;
    font-size: 12px;
    font-weight: bold;
    p {
        margin: 0;
    }
    display: none;

    @media ( max-width: 768px ){
        display: block;
    }
`


const CandidatosContainer = () => {

    const { isModalOpen, closeModal, openModal } = useModal();

    const { cc, ano } = useParams();

    const [loading, setLoading] = useState(false);
    const [candidatos, setCandidatos] = useState([]);

    const fetchCandidatos = async () => {

        try {

            const { data } = await axios.get(`https://sistemaintegrado.palmont.com.br/Painel/API/Cipa/Candidatos/index.php?cc=${cc}&ano=${ano}`);
            setCandidatos(data);

            console.log('atualizou');

        } catch (error) {

            console.log(error);

        }

    }

    useEffect(() => {

        fetchCandidatos();

        const intervalo = setInterval(fetchCandidatos, 30000);
        return () => clearInterval(intervalo);

    }, [])

    const openModalAddCandidato = () => {
        closeModal();
        openModal('modalAddCandidato');
    }

    const downloadRelatorio = async () => {

        setLoading(true);

        try {

            const response = await axios.get(
                `https://sistemaintegrado.palmont.com.br/Painel/API/Cipa/GenerateRelatorio/index.php?cc=${cc}&ano=${ano}`,
                { responseType: 'blob' }
            )

            const contentType = response.headers["Content-Type"];

            if (contentType && contentType.includes('application/json')) {

                const text = await response.data.text();
                const json = JSON.parse(text);
                console.error("Erro ao gerar relatório:", json.error || json.message);
                return;
            }

            const pdfBlob = new Blob([response.data], { type: "application/pdf" });
            saveAs(pdfBlob, `documento_${cc}_${ano}.pdf`)

        } catch (e) {

            console.error(e);

        } finally {
            setLoading(false);
        }

        closeModal();

    }

    return (
        <>
            <InfoVotacao>
                <p>{ano}</p>
                <p>{cc}</p>
            </InfoVotacao>
            <ListaCandidatos>
                {candidatos.map((candidato, index) => (
                    <CanditatoRow key={index}>
                        <Containerinfo>
                            <Foto>
                                <img src={candidato.foto} />
                            </Foto>
                            <CandidatoInfo>
                                <Nome>NOME: {candidato.nome} ({candidato.apelido})</Nome>
                                <Funcao>FUNÇÃO: {candidato.funcao}</Funcao>
                                <Numero>CHAPA: {candidato.chapa}</Numero>
                                <VotosContainerMobile>
                                    <p>VOTOS: {candidato.votos}</p>
                                </VotosContainerMobile>
                            </CandidatoInfo>
                        </Containerinfo>
                        <ContainerVotos percent={(candidato.votos / 1) * 100} color="#4caf50">
                            <QuantidadeVotos>{candidato.votos}</QuantidadeVotos>
                            <Votos>VOTOS</Votos>
                        </ContainerVotos>
                    </CanditatoRow>
                ))}
            </ListaCandidatos>
            {
                isModalOpen('sidebarCipaCandidatos') && (
                    <Overlay state={true} changeState={closeModal} >
                        <SideMenu>
                            <SideMenuBtn
                                button="CADASTRAR CANDIDATO"
                                clickFunc={openModalAddCandidato}
                            />
                            <SideMenuBtn
                                button="GERAR RELATÓRIO"
                                clickFunc={downloadRelatorio}
                                isLoading={loading}
                            />
                        </SideMenu>
                    </Overlay>
                )
            }
            {
                isModalOpen('modalAddCandidato') && (
                    <ModalAddCandidato
                        updateCandidatos={fetchCandidatos}
                    />
                )
            }
        </>
    )
}

export default CandidatosContainer;